import { CanvasLib } from "./canvas.mjs";
import { t as net_exports } from "./net.mjs";
//#region src/index.ts
/**
* Expanded Error
*/
var EError = class extends Error {
	status;
	constructor(message, status = 500) {
		let initializer;
		if (typeof message === "string") initializer = message;
		if (typeof message === "object") initializer = message.error_message || message.error;
		super(initializer);
		this.status = status;
	}
	toString() {
		return `Error: [${this.status}] ${this.message || "Unknown Error"}`;
	}
};
//#endregion
export { CanvasLib, EError, net_exports as net };

//# sourceMappingURL=index.mjs.map